import Loading from '@/shared/components/Carregando';
import Select from 'react-select';
import TabelaMovimentos from '@/modules/home/tabelamovimentos';
import { DataIso } from '@/shared/utils/datas';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { GetDefensorias } from '@/modules/structure/defensoria/defensoria.service';
import { GetNucleos } from '@/modules/structure/nucleo/nucleo.service';
import { ReadDefensoriaDto, ReadDefensorResponseDto, ReadNucleoDto } from '@/api.types';
import { useEffect, useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useSearchParams } from 'react-router-dom';

interface IOpcao { value: number; label: string; }

export default function HomeIndexMPage() {
  const tabelaMovimentosRef = useRef<{ buscarRegistros: () => void }>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const [loaded, setLoaded] = useState(false);

  const [listaDefensorias, setListaDefensorias] = useState<ReadDefensoriaDto[]>([]);
  const [listaNucleos, setListaNucleos] = useState<ReadNucleoDto[]>([]);

  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [nucleos, setNucleos] = useState<IOpcao[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);

  const [referenciaI, setReferenciaI] = useState(
    searchParams.get('referenciaI') || DataIso(new Date(), 'yyyy-MM'),
  );
  const [referenciaF, setReferenciaF] = useState(
    searchParams.get('referenciaF') || DataIso(new Date(), 'yyyy-MM'),
  );
  const [defensoriaId, setDefensoriaId] = useState(
    Number(searchParams.get('defensoriaId')) || 0,
  );
  const [nucleoId, setNucleoId] = useState(
    Number(searchParams.get('nucleoId')) || 0,
  );
  const [defensorId, setDefensorId] = useState(
    Number(searchParams.get('defensorId')) || 0,
  );

  useEffect(() => {
    Promise.all([
      GetDefensorias(0, 1000),
      GetNucleos(0, 1000),
      EnumerateDefensores(0, 1000),
    ])
      .then((res) => {
        res[0].objects.unshift({ id: -1, nome: '(todas)' } as ReadDefensoriaDto);
        setDefensorias(
          res[0].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setListaDefensorias(res[0].objects);

        res[1].objects.unshift({ id: -1, nome: '(todos)' } as ReadNucleoDto);
        setNucleos(
          res[1].objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setListaNucleos(res[1].objects);

        res[2].objects.unshift({ id: -1, nome: '(todos)' } as unknown as ReadDefensorResponseDto);
        setDefensores(
          res[2].objects.map((item) => {
            const nome = item.pessoa?.nome || '-';
            return { value: item.id, label: nome };
          }),
        );

        setLoaded(true);
      })
      .catch((res) => {
        console.error(res);
      });
  }, []);

  const handleBuscarRegistros = () => {
    if (tabelaMovimentosRef.current) {
      tabelaMovimentosRef.current.buscarRegistros();
    }
  };

  const atualizarFiltrosNaURL = () => {
    setSearchParams({
      referenciaI,
      referenciaF,
      defensoriaId: String(defensoriaId),
      nucleoId: String(nucleoId),
      defensorId: String(defensorId),
    });
  };

  useEffect(() => {
    atualizarFiltrosNaURL();
  }, [referenciaI, referenciaF, defensorId, nucleoId, defensoriaId]);

  return (
    <>
      <section className="text-center mt-4 mb-5">
        <h2>Corregedoria Geral</h2>
        <h5>Defensoria Pública do Estado de Sergipe</h5>
        <p>Relatórios de Atendimento dos Defensores</p>
      </section>
      {loaded ? (
        <>
          <div className="row">
            <div className="col-md-6">
              <label htmlFor="periodos-referencia" className="form-label">
                Período de Referência:
              </label>
              <div className="row" id="periodos-referencia">
                <div className="col-md-6">
                  <input
                    id="referenciaI"
                    name="referenciaI"
                    title="Dessa data..."
                    type="month"
                    className="form-control"
                    value={referenciaI}
                    onChange={(e) => {
                      setReferenciaI(DataIso(e.target.value, 'yyyy-MM'));
                    }}
                    required
                  />
                </div>
                {/* <span className='col-md-1 pt-2'>a</span> */}
                <div className="col-md-6">
                  <input
                    id="referenciaF"
                    name="referenciaF"
                    title="...até essa data."
                    type="month"
                    className="form-control"
                    value={referenciaF}
                    onChange={(e) => {
                      setReferenciaF(DataIso(e.target.value, 'yyyy-MM'));
                    }}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <label htmlFor="defensor" className="form-label">
                Defensor(a):
              </label>
              <Select
                id="defensor"
                options={defensores}
                defaultValue={defensores.find((a) => a.value === defensorId)}
                onChange={(e) => {
                  const sel = defensores.find((a) => a.value === e!.value);
                  const f: ReadDefensorResponseDto = {
                    id: sel!.value,
                    nome: sel!.label,
                  } as unknown as ReadDefensorResponseDto;
                  if (f?.id) setDefensorId(f.id);
                }}
              />
            </div>

            <div className="col-md-6 mt-3">
              <label htmlFor="defensoria" className="form-label">
                Defensoria:
              </label>
              <Select
                id="defensoria"
                options={defensorias}
                defaultValue={defensorias.find((a) => a.value === defensoriaId)}
                onChange={(e) => {
                  const sel = defensorias.find((a) => a.value === e!.value);
                  const f: ReadDefensoriaDto = {
                    id: sel!.value,
                    nome: sel!.label,
                  } as ReadDefensoriaDto;
                  if (f?.id) setDefensoriaId(f.id);
                }}
              />
            </div>

            <div className="col-md-5 mt-3">
              <label htmlFor="nucleo" className="form-label">
                Núcleo:
              </label>
              <Select
                id="nucleo"
                options={nucleos}
                defaultValue={nucleos.find((a) => a.value === nucleoId)}
                onChange={(e) => {
                  const sel = nucleos.find((a) => a.value === e!.value);
                  const f: ReadNucleoDto = {
                    id: sel!.value,
                    nome: sel!.label,
                  } as ReadNucleoDto;
                  if (f?.id) setNucleoId(f.id);
                }}
              />
            </div>
            <div className="col-md-1 mt-5">
              <button
                type="button"
                className="btn btn-primary ms-2"
                onClick={handleBuscarRegistros}
              >
                Filtrar
              </button>
            </div>
            <div ref={contentRef} className="col-md- mt-5">
              <div className="card">
                <div className="card-header text-center">
                  Tabela de Relatórios Pendentes e Enviados
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary float-end"
                    title="Imprimir Tabela"
                    onClick={() => {
                      reactToPrintFn();
                    }}
                  >
                    Imprimir
                  </button>
                </div>
                <div className="card-body">
                  <TabelaMovimentos
                    ref={tabelaMovimentosRef}
                    referenciaI={referenciaI}
                    referenciaF={referenciaF}
                    defensoria={defensoriaId}
                    nucleo={nucleoId}
                    defensor={defensorId}
                    defensorias={listaDefensorias}
                    nucleos={listaNucleos}
                  />
                </div>
                <div className="card-footer text-muted text-center">
                  Defensoria Pública do Estado de Sergipe
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
